module.exports = __webpack_public_path__ + "img/ball.be5030ca.webp";